export default __webpack_public_path__ + "static/media/19-LittleChurch.aa481f4d.jpeg";